export const SCHOOL_NAME = "Akademia";
export const SCHOOL_ADDRESS = "No. 10 U/Kwari, Ladanai Quarters, Hotoro, Kano";
export const SCHOOL_PHONE = "07036313352";
export const SCHOOL_EMAIL = "akademia@gmail.com";
export const SCHOOL_ACRONYM = "AKADEMIA";
export const SCHOOL_MOTTO = "Knowledge & Discipline";
export const THEME_COLOR_1 = "#FFD700"; // Gold
export const THEME_COLOR_2 = "#111D2B"; // Navy Blue
export const THEME_COLOR_3 = "#FFFFFF"; // White
export const RESULT_COLOR_1 = [17, 29, 43]; // #111d2b in RGB
export const RESULT_COLOR_2 = [0, 0, 128]; // for headings
export const RESULT_COLOR_3 = [230, 230, 250]; // for average summary